export default "__VITE_ASSET__DUpQF1aD__"